import {
  faUser,
  faCog,
  faShieldAlt,
  faBell,
  faPlug,
  faChartPie,
  faStar,
  faCreditCard,
  faMapMarkerAlt,
  faBars,
  faBug,
  faPalette,
  faCode,
  faGlobe,
  faUserPlus,
  faKey
} from "@awesome.me/kit-269fbef2e2/icons/duotone/solid";

export interface SettingsTab {
  label: string;
  key?: string;
  icon?: any; // FontAwesome icon
  type?: string;
  options?: SettingsTab[];
  badge?: number; // Optional badge count to display
}

export const SETTINGS_TABS: SettingsTab[] = [
  {
    label: "User Settings",
    type: "group",
    options: [
      { label: "Account", key: "account", icon: faUser },
      { label: "Theme", key: "theme", icon: faPalette },
      { label: "Security", key: "security", icon: faShieldAlt },
    ]
  },
  {
    label: "Company Settings",
    type: "group",
    options: [
      { label: "General", key: "general", icon: faCog },
      { label: "Calendar", key: "calendar", icon: faBell },
      { label: "Integrations", key: "integrations", icon: faPlug },
      { label: "Menus", key: "menus", icon: faBars },
      { label: "Modules", key: "modules", icon: faChartPie },
      { label: "Features", key: "features", icon: faCog },
      { label: "Diagnostics", key: "diagnostics", icon: faBug },
      { label: "Authorised Domains", key: "authorisedDomains", icon: faGlobe },
      { label: "SSO Providers", key: "ssoProviders", icon: faKey },
      { label: "Join Requests", key: "joinRequests", icon: faUserPlus },
    ]
  },
  {
    label: "Developer",
    type: "group",
    options: [
      { label: "API Tokens", key: "developer", icon: faCode },
    ]
  },
  {
    label: "MSP Settings",
    type: "group",
    options: [
      { label: "General", key: "mspSettings", icon: faMapMarkerAlt },
    ]
  },
];
